export default {
    issues: "Issues",
    statusChanges: "Status changes",
};
